<template>
  <div class="dashboard-table-wrapper" v-if="printers">
    <div>
      <table id="printer-table" class="dashboard-table">
        <thead>
        <tr>
          <th>&nbsp;</th>
          <th
            v-for="item, key in printers[0]"
            v-if="key !== 'manufacturer'"
            @click="sort(key)"
          >
            {{ key }}
            <i v-if="currentSort === key && currentSortDir == 'desc'" class="fas fa-arrow-down"></i>
            <i v-if="currentSort === key && currentSortDir == 'asc'" class="fas fa-arrow-up"></i>
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="printer in sortedPrinters">
          <td>
            <router-link :to="{name: 'printers.edit', params: {id: printer.id}}" tag="a" class="btn btn-sm btn-warning">Edit</router-link>
          </td>
          <td v-for="value, key in printer" v-if="key !== 'manufacturer'">
              <span v-if="key === 'manufacturer_id'">
                {{ printer.manufacturer.name }}
              </span>
            <span v-if="key !== 'manufacturer_id'">
                {{ value }}
              </span>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
  export default {
    created() {
      this.axios.get('/printers').then(response => {
        this.printers = response.data
      })
    },

    data() {
      return {
        printers: [],
        currentSort: 'id',
        currentSortDir: 'asc'
      }
    },

    mounted() {
      document.body.classList.add('has-table');
    },

    destroyed() {
      document.body.classList.remove('has-table');
    },

    methods: {
      sort: function (s) {
        if (s === this.currentSort) {
          this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
        }
        this.currentSort = s;
      }
    },

    computed: {
      sortedPrinters: function () {
        return this.printers.sort((a, b) => {
          let modifier = 1;
          if (this.currentSortDir === 'desc') modifier = -1;
          if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
          if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
          return 0;
        });
      }
    },
  }
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/views/Printers/Index.vue